let textMustMatchDirective = (_) => {
    'ngInject';
    return {
        restrict: 'A',
        'require': 'ngModel',
        scope: {
            fpTextMustMatch: '='
        },
        link: (scope, element, attributes, controller) => {
            scope.$watch(() => {
                let modelValue = controller.$modelValue || controller.$$invalidModelValue;
                return (controller.$pristine && _.isUndefined(modelValue)) || scope.fpTextMustMatch === modelValue;
            }, (currentValue) => {
                controller.$setValidity('match', currentValue);
            });
        }
    };
};

export default textMustMatchDirective;